import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
/**
 * {
 *   component: Component to render in the cell,
 *   shouldRender: Function returning a boolean whether to render the component or not.
 *   mapCellPropsToComponentProps: Mapper function to map cell props to custom component props if needed.
 * }
 */

import _stubTrue from 'lodash/stubTrue';
import _noop from 'lodash/noop';
var CellConfig = /*#__PURE__*/function () {
  function CellConfig() {
    _classCallCheck(this, CellConfig);
    this.component = null;
    this.shouldRender = _stubTrue;
  }
  _createClass(CellConfig, [{
    key: "setComponent",
    value: function setComponent(component) {
      this.component = component;
      return this;
    }
  }, {
    key: "setShouldRender",
    value: function setShouldRender() {
      var shouldRender = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _stubTrue;
      this.shouldRender = shouldRender;
      return this;
    }
  }, {
    key: "setMapCellPropsToComponentProps",
    value: function setMapCellPropsToComponentProps() {
      var mapCellPropsToComponentProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _noop;
      this.mapCellPropsToComponentProps = mapCellPropsToComponentProps;
      return this;
    }
  }, {
    key: "getComponent",
    value: function getComponent() {
      return this.component;
    }
  }, {
    key: "getShouldRender",
    value: function getShouldRender() {
      return this.shouldRender;
    }
  }, {
    key: "getMapCellPropsToComponentProps",
    value: function getMapCellPropsToComponentProps() {
      return this.mapCellPropsToComponentProps;
    }
  }]);
  return CellConfig;
}();
export default CellConfig;